import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IOfficeProductivityPayload } from '../types/LocationSettings';

/** Saves one location's productivity (operatories, permanent staff, booking-out window). */
export const updateOfficeProductivity = async (
  officeId: string,
  productivity: IOfficeProductivityPayload,
): Promise<unknown> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch(
    '/users/office-productivity',
    { productivity },
    { headers: { ...headers, 'x-office': officeId } },
  );
  return data;
};
